import React, { useMemo } from 'react';
import ReactApexChart from 'react-apexcharts';

/**
 * Tiny radial bar tuned for license-health display.
 * Shows only the percentage value in the center. No series name ("series-1").
 */
const LicenseRadial = ({ percent = 0, color = '#00b1c2', height = 140 }) => {
    const pct = Math.max(0, Math.min(Math.round(percent), 100));
    const series = useMemo(() => [pct], [pct]);

    const options = useMemo(() => ({
        chart: { type: 'radialBar', sparkline: { enabled: false }, offsetY: -10 },
        colors: [color],
        plotOptions: {
            radialBar: {
                hollow: { size: '55%' },
                track: { background: 'rgba(150,150,150,0.12)', strokeWidth: '90%' },
                dataLabels: {
                    name: { show: false },
                    value: {
                        show: true,
                        offsetY: 6,
                        fontSize: '18px',
                        fontWeight: 600,
                        color: '#2b2b41',
                        formatter: v => `${v}%`
                    }
                }
            }
        },
        stroke: { lineCap: 'round' },
        labels: ['']
    }), [color]);

    return (
        <ReactApexChart
            type='radialBar'
            height={height}
            series={series}
            options={options}
        />
    );
};

export default LicenseRadial;
